import { Textarea } from "@mantine/core";
import { useFormProvider } from "../../../../providers";

export function AddressComponent() {
  const { address } = useFormProvider();

  return <Textarea minRows={5} value={address} disabled />;
}
